// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1k-XS","footer":"ModalUpdate_footer__1wozK"};